import React, { useState, forwardRef } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import Papa from 'papaparse';
import { Container, ButtonGroup } from 'react-bootstrap';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import DatePicker from 'react-datepicker';
import apiService from '../../../Auth/apiService';
import MenuAdministrativos from './MenuAdministrativos';
import ButtonsMenu from '../../Utils/ButtonsMenu';
import { useAuth } from '../../../Auth/AuthContext';
import { FaCalendar, FaList, FaSearch } from 'react-icons/fa';

const CustomInput = forwardRef(function CustomInput({ value, onClick }, ref) {
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick(e);
        }
    };
    return (
        <button
            type="button"
            className="custom-input"
            onClick={onClick}
            onKeyDown={handleKeyDown}
            ref={ref}
            aria-label="Seleccionar fecha"
            style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
        >
            <input
                value={value}
                readOnly
                className='widthCalendar'
                data-tooltip-id='tooltiparriba'
                data-tooltip-content="Seleccione fecha"
                tabIndex={-1}
                aria-readonly="true"
                style={{ pointerEvents: 'none', background: 'transparent', border: 'none' }}
            />
            <FaCalendar />
        </button>
    );
});

export default function InformeOrganizaciones(){
    const { token } = useAuth();
    const navigate = useNavigate();
    const fecha = new Date();
    const { control, handleSubmit, watch, formState: { errors }} = useForm({
        defaultValues: { 
            FechaInicial: fecha, 
            FechaFinal: fecha
        }
    });
    const [filters, setFilters] = useState({
        com_comuna: '',
    });
    const [Cargando, setCargando] = useState(false);
    const [datosOrganizacion, setDatosOrganizacion] = useState([]);
    const [swalProps, setSwalProps] = useState();
    
    const onSubmit = (data) => {
        fetchData(
            data.FechaInicial.toLocaleDateString('en-CA'),
            data.FechaFinal.toLocaleDateString('en-CA')
        );
    };
    async function fetchData (FechaI, FechaF) {
        const url = `/organizaciones/generarinformeorganizaciones?FechaInicio=${FechaI}&FechaFinal=${FechaF}`;
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data.organizaciones;
            setDatosOrganizacion(result);
        } catch (error) {
            if (error.response && error.response.status === 409) {
                setSwalProps({
                    show: true,
                    title: 'Advertencia',
                    text: error.response.data.message || 'No se encontraron registros para las fechas seleccionadas.',
                    icon: 'warning',
                });
            } else {
                setSwalProps({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo obtener la informaci&oacute;n de organizaciones.',
                    showConfirmButton: true,
                });
            }
        } finally {
            setCargando(false);
        }
    };
    async function exportarCSV() {
        setCargando(true);
        const FechaI = watch('FechaInicial').toLocaleDateString('en-CA')
        const FechaF = watch('FechaFinal').toLocaleDateString('en-CA')
        const url = `/organizaciones/generarinformeorganizaciones?FechaInicio=${FechaI}&FechaFinal=${FechaF}&csv=${true}`;
        try {
            const response = await apiService.get(url, token, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', 'Organizaciones.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
         } catch (error) {
             console.error('Error fetching data:', error);
         } finally {
             setCargando(false);
         }
    }

    // Get unique values for filters from datosOrganizacion
    const uniqueValues = (key) => [...new Set(datosOrganizacion.map(row => row[key]).filter(Boolean))];

    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 50;

    // Filtered data based on filters
    const filteredData = datosOrganizacion.filter(row =>
        (!filters.com_comuna || row.com_comuna === filters.com_comuna)
        // Add more filter conditions as needed
    );

    // Pagination logic
    const totalRows = filteredData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const paginatedData = filteredData.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    // Handler for page change
    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) setCurrentPage(page);
    };

    // Reset to first page when filters change
    React.useEffect(() => {
        setCurrentPage(1);
    }, [filters, datosOrganizacion]);

    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Informe organizaciones</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to="/" >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to="/caracterizacion/informesadministrativos" > Administrativos</NavLink></li>
                        <li className="breadcrumb-item active"> Informe organizaciones</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuAdministrativos/>
                    <div className="row">
                        <div className="col-md-12">
                            <div className='card'>
                                <div className='card-header' style={{display: 'flex', justifyContent: 'flex-end', textAlign: 'right',}}> 
                                    <ButtonsMenu data={filteredData} titulo={'Informe organizaciones'} exportarCSV={exportarCSV}/>
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <Container>
                                            
                                            <ButtonGroup aria-label="Basic example">
                                                <label htmlFor="FechaInicial">
                                                    <Controller
                                                        control={control}
                                                        name="FechaInicial"
                                                        render={({ field }) => (
                                                            <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block', height: 38 }}>
                                                                <DatePicker
                                                                    id="FechaInicial"
                                                                    placeholderText="fecha"
                                                                    onChange={(date) => field.onChange(date)}
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    selected={field.value}
                                                                    customInput={<CustomInput />}
                                                                    locale="es"
                                                                    dateFormat="yyyy-MM-dd"
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                </label>
                                                {errors.FechaInicial && <p style={{color: 'red'}}>Fecha inicial</p>}
                                                <label htmlFor="FechaFinal">
                                                    <Controller
                                                        control={control}
                                                        name="FechaFinal"
                                                        render={({ field }) => (
                                                            <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block', height: 38 }}>
                                                                <DatePicker
                                                                    id="FechaFinal"
                                                                    placeholderText="fecha"
                                                                    onChange={(date) => field.onChange(date)}
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    selected={field.value}
                                                                    customInput={<CustomInput />}
                                                                    locale="es"
                                                                    dateFormat="yyyy-MM-dd"
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                    {errors.FechaFinal && <p style={{color: 'red'}}>Fecha final</p>}
                                                </label>
                                                <button
                                                    type="submit"
                                                    className="img-square elevation-1"
                                                    style={{
                                                        fontSize: '0.7rem',
                                                        padding: '2px 12px',
                                                        height: 38,
                                                        minWidth: '80px',
                                                        verticalAlign: 'middle',
                                                        border: '1px solid #6daff1ff',
                                                        borderRadius: 4,
                                                        background: '#abbdcfff',
                                                        display: 'inline-flex',
                                                        alignItems: 'center'
                                                    }}
                                                    data-tooltip-id='tooltiparriba'
                                                    data-tooltip-content="Consultar"
                                                >
                                                    <FaSearch /> Buscar
                                                </button>
                                            </ButtonGroup>
                                        </Container>
                                    </form>
                                </div>
                                {datosOrganizacion && datosOrganizacion.length > 0 && <div className="card-body table-responsive p-0">
                                    {/* Pagination controls */}
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '1rem 0' }}>
                                        <button
                                            className="btn btn-secondary btn-sm"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Anterior
                                        </button>
                                        <span style={{ margin: '0 1rem' }}>
                                            Página {currentPage} de {totalPages}
                                        </span>
                                        <button
                                            className="btn btn-secondary btn-sm"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Siguiente
                                        </button>
                                    </div>
                                    <table className="table table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th>id</th>
                                                <th>com_comuna</th>
                                                <th>org_constintucionlegal</th>
                                                <th>org_correo</th>
                                                <th>org_direccion</th>
                                                <th>org_fechaactualizacion</th>
                                                <th>org_nit</th>
                                                <th>org_nombre</th>
                                                <th>org_nombrerepresentante</th>
                                                <th>org_observaciones</th>
                                                <th>org_telefono</th>
                                                <th>org_tematica</th>
                                                <th>org_tieneplantrabajo</th>
                                                <th>org_tienesede</th>
                                                <th>org_totalintegrantes</th>
                                                <th>org_totalintegrantevictima</th>
                                                <th>org_userid</th>
                                            </tr>
                                            <tr>
                                                <th></th>
                                                <th>
                                                    <select
                                                        value={filters.com_comuna}
                                                        onChange={e => setFilters(f => ({ ...f, com_comuna: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {uniqueValues('com_comuna').map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paginatedData.map((row, idx) => (
                                                <tr key={idx}>
                                                    <td>{row.id}</td>
                                                    <td>{row.com_comuna}</td>
                                                    <td>{row.org_constintucionlegal}</td>
                                                    <td>{row.org_correo}</td>
                                                    <td>{row.org_direccion}</td>
                                                    <td>{row.org_fechaactualizacion}</td>
                                                    <td>{row.org_nit}</td>
                                                    <td>{row.org_nombre}</td>
                                                    <td>{row.org_nombrerepresentante}</td>
                                                    <td>{row.org_observaciones}</td>
                                                    <td>{row.org_telefono}</td>
                                                    <td>{row.org_tematica}</td>
                                                    <td>{row.org_tieneplantrabajo}</td>
                                                    <td>{row.org_tienesede}</td>
                                                    <td>{row.org_totalintegrantes}</td>
                                                    <td>{row.org_totalintegrantevictima}</td>
                                                    <td>{row.org_userid}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}